"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolReferenceMarkdownDirectiveDefinition = void 0;
exports.formatToolReferenceDirective = formatToolReferenceDirective;
const MarkdownDirectiveDefinition_1 = require("./MarkdownDirectiveDefinition");
exports.ToolReferenceMarkdownDirectiveDefinition = Object.freeze({
    allowedAttributes: ['toolId'],
    contentAttributeName: 'toolId',
    directive: 'tool',
    nodeTypes: [MarkdownDirectiveDefinition_1.NodeTypes.TextDirective],
});
function formatToolReferenceDirective(toolId) {
    return `:${exports.ToolReferenceMarkdownDirectiveDefinition.directive}[${(0, MarkdownDirectiveDefinition_1.escapeDirectiveContent)(toolId)}]`;
}
//# sourceMappingURL=ToolReference.js.map